import ButtonEditShuma from './ButtonEditShuma';

export default ButtonEditShuma;
